import axios from 'axios';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Function to get CSRF token from cookie
const getCsrfToken = () => {
    const name = 'csrftoken';
    let cookieValue = null;
    if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            if (cookie.substring(0, name.length + 1) === (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
}

const createAPIinstance = () => {
    const csrfToken = getCsrfToken();
    return axios.create({
        baseURL: `${process.env.REACT_APP_BASE_API_URL}/api/announcements`,
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': csrfToken
        },
        withCredentials: false
    })
}

// Action creator for fetching announcements
export const fetchAnnouncements = createAsyncThunk(
  'announcements/fetch',
  async (_, { rejectWithValue }) => {
    try {
      const api = createAPIinstance();
      
      // Get the announcements from the API
      const { data } = await api.get('/');
      
      return data;
    } catch (error) {
      return rejectWithValue(
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.message
      );
    }
  }
);

// Slice for announcement state
const announcementSlice = createSlice({
  name: 'announcements',
  initialState: {
    announcements: [],
    loading: false,
    error: null,
  },
  reducers: {
    // Reset announcements state
    announcementsReset: (state) => {
      state.announcements = [];
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAnnouncements.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAnnouncements.fulfilled, (state, action) => {
        state.loading = false;
        state.announcements = action.payload;
      })
      .addCase(fetchAnnouncements.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { announcementsReset } = announcementSlice.actions;
export default announcementSlice.reducer; 